// main filter active from is name activefrom
// main filter active to is name activeto

import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsSubject, roledrp } from '../../Helper'
import moment from 'moment'
import { campustableApi } from '../../../utils/AdminDashApi/CampusApi'
import { fetchCampusList } from '../../../utils/Api_Calls/api_calls_all'



const CampusComp = () => {
  const [activefrom,setactivefrom] = useState("")
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")

  const [campusname1,setcampusname1] = useState("")
  const [campustitle1,setcampustitle1] = useState("")
  const [holdingno1,setholdingno1] = useState("")
  const [street1,setstreet1] = useState("")
  const [area1,setarea1] = useState("")
  const [city1,setcity1] = useState("")
  const [state1,setstate1] = useState("")
  const [district1,setdistrict1] = useState("")
  const [mapurl1,setmapurl1] = useState("")
  const [phoneno1,setphoneno1] = useState("")
  const [email1,setemail1] = useState("")
  const [longitude1,setlongitude1] = useState("")
  const [latitude1,setlatitude1] = useState("")

  const [labelcampusname1,setlabelcampusname1] = useState("")
  const [labelcampustitle1,setlabelcampustitle1] = useState("")
  const [labelholdingno1,setlabelholdingno1] = useState("")
  const [labelstreet1,setlabelstreet1] = useState("")
  const [labelarea1,setlabelarea1] = useState("")
  const [labelcity1,setlabelcity1] = useState("")
  const [labelstate1,setlabelstate1] = useState("")
  const [labeldistrict1,setlabeldistrict1] = useState("")
  const [labelmapurl1,setlabelmapurl1] = useState("")
  const [labelphoneno1,setlabelphoneno1] = useState("")
  const [labelemail1,setlabelemail1] = useState("")
  const [labellongitude1,setlabellongitude1] = useState("")
  const [labellatitude1,setlabellatitude1] = useState("")

  const [bordercampusname1,setbordercampusname1] = useState("")
  const [bordercampustitle1,setbordercampustitle1] = useState("")
  const [borderholdingno1,setborderholdingno1] = useState("")
  const [borderstreet1,setborderstreet1] = useState("")
  const [borderarea1,setborderarea1] = useState("")
  const [bordercity1,setbordercity1] = useState("")
  const [borderstate1,setborderstate1] = useState("")
  const [borderdistrict1,setborderdistrict1] = useState("")
  const [bordermapurl1,setbordermapurl1] = useState("")
  const [borderphoneno1,setborderphoneno1] = useState("")
  const [borderemail1,setborderemail1] = useState("")
  const [borderlongitude1,setborderlongitude1] = useState("")
  const [borderlatitude1,setborderlatitude1] = useState("")

  const [campusname2,setcampusname2] = useState("")
  const [campustitle2,setcampustitle2] = useState("")
  const [holdingno2,setholdingno2] = useState("")
  const [street2,setstreet2] = useState("")
  const [area2,setarea2] = useState("")
  const [city2,setcity2] = useState("")
  const [state2,setstate2] = useState("")
  const [district2,setdistrict2] = useState("")
  const [mapurl2,setmapurl2] = useState("")
  const [phoneno2,setphoneno2] = useState("")
  const [email2,setemail2] = useState("")
  const [longitude2,setlongitude2] = useState("")
  const [latitude2,setlatitude2] = useState("")

  const [labelcampusname2,setlabelcampusname2] = useState("")
  const [labelcampustitle2,setlabelcampustitle2] = useState("")
  const [labelholdingno2,setlabelholdingno2] = useState("")
  const [labelstreet2,setlabelstreet2] = useState("")
  const [labelarea2,setlabelarea2] = useState("")
  const [labelcity2,setlabelcity2] = useState("")
  const [labelstate2,setlabelstate2] = useState("")
  const [labeldistrict2,setlabeldistrict2] = useState("")
  const [labelmapurl2,setlabelmapurl2] = useState("")
  const [labelphoneno2,setlabelphoneno2] = useState("")
  const [labelemail2,setlabelemail2] = useState("")
  const [labellongitude2,setlabellongitude2] = useState("")
  const [labellatitude2,setlabellatitude2] = useState("")

  const [bordercampusname2,setbordercampusname2] = useState("")
  const [bordercampustitle2,setbordercampustitle2] = useState("")
  const [borderholdingno2,setborderholdingno2] = useState("")
  const [borderstreet2,setborderstreet2] = useState("")
  const [borderarea2,setborderarea2] = useState("")
  const [bordercity2,setbordercity2] = useState("")
  const [borderstate2,setborderstate2] = useState("")
  const [borderdistrict2,setborderdistrict2] = useState("")
  const [bordermapurl2,setbordermapurl2] = useState("")
  const [borderphoneno2,setborderphoneno2] = useState("")
  const [borderemail2,setborderemail2] = useState("")
  const [borderlongitude2,setborderlongitude2] = useState("")
  const [borderlatitude2,setborderlatitude2] = useState("")

  const [editId,seteditId] = useState(null)
  
 
 
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            // console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        console.log("past")
      } else {
        console.log("future")
      }
  },[])
  const [classdrp,setClassdrp] = useState("")
  
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myid)    
  }
    
  

   

    const [show3, setShow3] = useState(false);

    const handleClose2=()=>{
      setShow3(false)
    }
    const [modalitem,setmodalitem] = useState(null)
    const handleShow3 = (myitem) =>{
      
      seteditId(myitem.campusId)
      setcampusname2(myitem.campusName)
      setcampustitle2(myitem.campusTitle)
      setholdingno2(myitem.holdingNumber)
      setstreet2(myitem.street)
      setarea2(myitem.area)
      setcity2(myitem.city)
      setstate2(myitem.state)
      setdistrict2(myitem.district)
      setmapurl2(myitem.mapUrl)
      setphoneno2(myitem.phoneNumber)
      setemail2(myitem.email)
      setlongitude2(myitem.longitude)
      setlatitude2(myitem.latitude)
      
      setShow3(true)
    };

    const handleDelete= async(myitem)=>{
      await DeleteCampusById(myitem.campusId)
    }
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [campusListResponse,setcampusListResponse] = useState([])
  const [filteredArr,setfilteredArr] = useState(campusListResponse?campusListResponse:campustableApi.data)


  useEffect(()=>{
    setfilteredArr(campusListResponse)
  },[campusListResponse])

 



  const [tempfilteredarr,settempfilteredarr] = useState([])
    // useEffect(() => {
    //     // Fetch items from another resources.
    //     const endOffset = itemOffset + itemsPerPage;        
    //     setCurrentItems(filteredArr.slice(itemOffset, endOffset));        
    //     setPageCount(Math.ceil(filteredArr.length / itemsPerPage));
        
    //   }, [itemOffset, itemsPerPage]);
    //   let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
    //   useEffect(()=>{
    //     const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    //     settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
    //     setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
    //     setpagecountoffilter(filteredArr.length)
    //   },[itemOffsetfiltered,itemsPerPagefiltered,tempfilteredarr,filteredArr])
    
      // Invoke when user click to request another page.
      // const handlePageClick = (event) => {
      //   const newOffset = event.selected * itemsPerPage % filteredArr.length;        
      //   setpaginatenumselected(event.selected);
      //   setItemOffset(newOffset);
      // };
      // const handlePageClickfiltered = (event) => {
      //   const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
      //   setpaginatenumselectedfiltered(event.selected);
      //   setItemOffsetfiltered(newOffsetf);
      // };
      let [pagecountoffilter,setpagecountoffilter] = useState(campusListResponse?campusListResponse.length:campustableApi.length)
      useEffect(() => {
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
        settempfilteredarr(tempArr);
        setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
        setitemsPerPagefiltered(show?show:10)
        //flag2
      }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show,campusListResponse]);
    
          const handlePageClick = (event) => {
            const newOffset = event.selected * itemsPerPage % campusListResponse.length;        
            setpaginatenumselected(event.selected);
            setItemOffset(newOffset);
          };
          const handlePageClickfiltered = (event) => {
            const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
            setpaginatenumselectedfiltered(event.selected);
            setItemOffsetfiltered(newOffsetf);
          };
    
      const handleClose=()=>{
        setShow2(false)
      }
      const [rolemodalvalue,setrolemodalvalue] = useState("")
      const [subjectnamemodalvalue,setsubjectnamemodalvalue] = useState("")
      const [classnamemodalvalue,setclassnamemodalvalue] = useState("")
      
      const [subjectnamemodalvalue2,setsubjectnamemodalvalue2] = useState("")
      const [classnamemodalvalue2,setclassnamemodalvalue2] = useState("")
      const [rolemodalvalue2,setrolemodalvalue2] = useState("")
      const drpfuncclassnamemodal=(mystatus,myid)=>{
        setclassnamemodalvalue(myid)
        
          
      }
      const drpfuncclassnamemodal2=(mystatus,myid)=>{
        setclassnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal=(mystatus,myid)=>{
        setrolemodalvalue(mystatus)
        
          
      }
      const drpfuncsubjectnamemodal=(mystatus,myid)=>{
        setsubjectnamemodalvalue(myid)
        
          
      }
      const drpfuncsubjectnamemodal2=(mystatus,myid)=>{
        setsubjectnamemodalvalue2(myid)
        
          
      }
      const drpfuncrolemodal2=(mystatus,myid)=>{
        setrolemodalvalue2(mystatus)
        console.log("manualselect" , mystatus)
          
      }
      
      const handlesearch =()=>{
    
        setactivefrom("")
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
    const handleModaleditsave=()=>{
      console.log(rolemodalvalue2)
      setShow3(false)
    }

   
    
    const handleActiveFrom = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom(dtfinalc)
        }
        
        
    }
    const [activefromModal1,setactivefromModal1] = useState("")
    const handleActiveFromModal1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal1(dtfinalc)
        }
        
        
    }
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(dtfinalc)

            
        }
        
        
    }
    const [activeToModal1,setactiveToModal1] = useState("")
      const handleActiveToModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveToModal1(dtfinalc)

            
        }
        
        
    }
    const [newsDate1,setnewsDate1] = useState("")
      const handlenewsDateModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate1(dtfinalc)

            
        }
        
        
    }
    const [newsDate2,setnewsDate2] = useState("")
      const handlenewsDateModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setnewsDate2(dtfinalc)

            
        }
        
        
    }
    // Modal2activefromto 
    
    const handleActiveFrom2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom2(dtfinalc)
        }
        
        
    }
    const [activefromModal2,setactivefromModal2] = useState("")
    const handleActiveFromModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal2(dtfinalc)
        }
        
        
    }
      const handleActiveTo2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo2(dtfinalc)

            
        }
        
        
    }
    const [activeToModal2,setactiveToModal2] = useState("")
      const handleActiveToModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveToModal2(dtfinalc)

            
        }
        
        
    }
    

   
   
    const [subgroupdesMod2,setsubgroupdesMod2] = useState("")
    const handlesubgroupdesMod2=(e)=>{
        setsubgroupdesMod2(e.target.value)
    }
   
    const [newsTitleMod1,setnewsTitleMod1] = useState("")
    const handlenewsTitleMod1=(e)=>{
        setnewsTitleMod1(e.target.value)
    }
    const [newsTitleMod2,setnewsTitleMod2] = useState("")
    const handlenewsTitleMod2=(e)=>{
        setnewsTitleMod2(e.target.value)
    }
    const [descriptionMod1,setdescriptionMod1] = useState("")
    const handledescriptionMod1=(e)=>{
        setdescriptionMod1(e.target.value)
    }
    const [descriptionMod2,setdescriptionMod2] = useState("")
    const handledescriptionMod2=(e)=>{
        setdescriptionMod2(e.target.value)
    }


     
    const [activefromModal1label,setactivefromModal1label] = useState("")
    const [newsDatelabel,setnewsDatelabel] = useState("")
    const [activetoModal1label,setactivetoModal1label] = useState("")
    const [newsTitleMod1label,setnewsTitleMod1label] = useState("")
    const [descriptionMod1label,setdescriptionMod1label] = useState("")
    
    const [descriptionMod2label,setdescriptionMod2label] = useState("")
    const [activefromModal1label2,setactivefromModal1label2] = useState("")
    const [newsDatelabel2,setnewsDatelabel2] = useState("")
    const [activetoModal1label2,setactivetoModal1label2] = useState("")
    const [newsTitleMod2label,setnewsTitleMod2label] = useState("")

   


    // Validation 

    const handlesaveModal1 = async (e)=>{
      
        e.preventDefault()
      
        if(!campusname1 && campusname1==""){
            setlabelcampusname1("Campus name required")
            setbordercampusname1(true)
          }
          else{
            setlabelcampusname1("")
            setbordercampusname1(false)
          }
          if(!campustitle1 && campustitle1==""){
            setlabelcampustitle1("Campus title required")
            setbordercampustitle1(true)
          }
          else{
            setlabelcampustitle1("")
            setbordercampustitle1(false)
          }
          if(!holdingno1 && holdingno1==""){
            setlabelholdingno1("Holding no required")
            setborderholdingno1(true)
          }
          else{
            setlabelholdingno1("")
            setborderholdingno1(false)
          }
          if(!street1 && street1==""){
            setlabelstreet1(" street required")
            setborderstreet1(true)
          }
          else{
            setlabelstreet1("")
            setborderstreet1(false)
          }
          
          if(!area1 && area1==""){
            setlabelarea1("Area required")
            setborderarea1(true)
          }
          else{
            setlabelarea1("")
            setborderarea1(false)
          }
          if(!city1 && city1==""){
            setlabelcity1("City required")
            setbordercity1(true)
          }
          else{
            setlabelcity1("")
            setbordercity1(false)
          }
          if(!state1 && state1==""){
            setlabelstate1("State required")
            setborderstate1(true)
          }
          else{
            setlabelstate1("")
            setborderstate1(false)
          }
          if(!district1 && district1==""){
            setlabeldistrict1("District required")
            setborderdistrict1(true)
          }
          else{
            setlabeldistrict1("")
            setborderdistrict1(false)
          }
          if(!mapurl1 && mapurl1==""){
            setlabelmapurl1("Mapurl required")
            setbordermapurl1(true)
          }
          else{
            setlabelmapurl1("")
            setbordermapurl1(false)
          }
          if(!phoneno1 && phoneno1==""){
            setlabelphoneno1("Phone No required")
            setborderphoneno1(true)
          }
          else{
            setlabelphoneno1("")
            setborderphoneno1(false)
          }
          if(!email1 && email1==""){
            setlabelemail1("Email required")
            setborderemail1(true)
          }
          else if (email1 && !/\S+@\S+\.\S+/.test(email1)) {
            setlabelemail1('Email format is incorrect')
            setborderemail1(true)
        }
          else{
            setlabelemail1("")
            setborderemail1(false)
          }
          if(!longitude1 && longitude1==""){
            setlabellongitude1("Longitude required")
            setborderlongitude1(true)
          }
          else{
            setlabellongitude1("")
            setborderlongitude1(false)
          }
          if(!latitude1 && latitude1==""){
            setlabellatitude1("Latitude required")
            setborderlatitude1(true)
          }
          else{
            setlabellatitude1("")
            setborderlatitude1(false)
          }
      
          if(
            campusname1.length !== 0 &&
            campustitle1.length !== 0 &&
            holdingno1.length !== 0 &&
            street1.length !== 0 &&
            area1.length !== 0 &&
            city1.length !== 0 &&
            state1.length !== 0 &&
            district1.length !== 0 &&
            mapurl1.length !== 0 &&
            phoneno1.length !== 0 &&
            email1.length !== 0 &&
            longitude1.length !== 0 &&
            latitude1.length !== 0 
          ){            
            const finalArr = {
              "CampusId": 0,
              "CampusName": campusname1,
              "CampusTitle": campustitle1,
              "HoldingNumber": holdingno1,
              "Street": street1,
              "Area": area1,
              "City": city1,
              "State": state1,
              "District": district1,
              "PhoneNumber": phoneno1,
              "MapUrl": mapurl1, 
              "Latitude": latitude1,
              "Longitude": longitude1,
              "Email": email1,

            }
            await SaveOrUpdateCampusInfo(finalArr)
            setShow2(false)
          }
          else{
            console.log("Not entered validaiton")
          }

    }
     // api funcitons
     async function SaveOrUpdateCampusInfo(data) {
      console.log(data);
      try {
        axios
          .post(
            "https://localhost:7229/api/Admin/SaveOrUpdateCampus",
            data,
            headers
          )
          .then(function (response) {
            setcampusListResponse(response.data);
          });
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    }
     async function DeleteCampusById(myid) {
      //https://localhost:7229/api/Admin/DeleteCampusById?myid=5
      try {
        axios
          .delete(
            `https://localhost:7229/api/Admin/DeleteCampusById?myid=${myid}`,
            
            headers
          )
          .then(function (response) {
            setcampusListResponse(response.data);
          });
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    }
   
  //  useEffect(()=>{
  //   console.log(newArr)
  //  },[newArr])
    // Modal 2
   
    const handlesaveModal2 = async (e)=>{
      e.preventDefault()
      
      if(campusname2==null || campusname2==""){
        setlabelcampusname2("Campus name required")
        setbordercampusname2(true)
      }
      else{
        setlabelcampusname2("")
        setbordercampusname2(false)
      }
      if(campustitle2==null || campustitle2==""){
        setlabelcampustitle2("Campus title required")
        setbordercampustitle2(true)
      }
      else{
        setlabelcampustitle2("")
        setbordercampustitle2(false)
      }
      if(holdingno2==null || holdingno2==""){
        setlabelholdingno2("Holding no required")
        setborderholdingno2(true)
      }
      else{
        setlabelholdingno2("")
        setborderholdingno2(false)
      }
      if(street2==null || street2==""){
        setlabelstreet2(" street required")
        setborderstreet2(true)
      }
      else{
        setlabelstreet2("")
        setborderstreet2(false)
      }
      
      if(area2==null || area2==""){
        setlabelarea2("Area required")
        setborderarea2(true)
      }
      else{
        setlabelarea2("")
        setborderarea2(false)
      }
      if(city2==null || city2==""){
        setlabelcity2("City required")
        setbordercity2(true)
      }
      else{
        setlabelcity2("")
        setbordercity2(false)
      }
      if(state2==null || state2==""){
        setlabelstate2("State required")
        setborderstate2(true)
      }
      else{
        setlabelstate2("")
        setborderstate2(false)
      }
      if(district2==null || district2==""){
        setlabeldistrict2("District required")
        setborderdistrict2(true)
      }
      else{
        setlabeldistrict2("")
        setborderdistrict2(false)
      }
      if(mapurl2==null || mapurl2==""){
        setlabelmapurl2("Mapurl required")
        setbordermapurl2(true)
      }
      else{
        setlabelmapurl2("")
        setbordermapurl2(false)
      }
      if(phoneno2==null || phoneno2==""){
        setlabelphoneno2("Phone No required")
        setborderphoneno2(true)
      }
      else{
        setlabelphoneno2("")
        setborderphoneno2(false)
      }
      if(email2==null || email2==""){
        setlabelemail2("Email required")
        setborderemail2(true)
      }
      else if (email2 && !/\S+@\S+\.\S+/.test(email2)) {
        setlabelemail2('Email format is incorrect')
        setborderemail2(true)
    }
      else{
        setlabelemail2("")
        setborderemail2(false)
      }
      if(longitude2==null || longitude2==""){
        setlabellongitude2("Longitude required")
        setborderlongitude2(true)
      }
      else{
        setlabellongitude2("")
        setborderlongitude2(false)
      }
      if(latitude2==null || latitude2==""){
        setlabellatitude2("Latitude required")
        setborderlatitude2(true)
      }
      else{
        setlabellatitude2("")
        setborderlatitude2(false)
      }
      if(
        campusname2.length !== 0 &&
        campustitle2.length !== 0 &&
        holdingno2.length !== 0 &&
        street2.length !== 0 &&
        area2.length !== 0 &&
        city2.length !== 0 &&
        state2.length !== 0 &&
        district2.length !== 0 &&
        mapurl2.length !== 0 &&
        phoneno2.length !== 0 &&
        email2.length !== 0 &&
        longitude2.length !== 0 &&
        latitude2.length !== 0
        ){
        const finalArr = {  
          "CampusId": editId,
          "CampusName": campusname2,
          "CampusTitle": campustitle2,
          "HoldingNumber": holdingno2,
          "Street": street2,
          "Area": area2,
          "City": city2,
          "State": state2,
          "District": district2,
          "PhoneNumber": phoneno2,
          "MapUrl": mapurl2,
          "Latitude": latitude2,
          "Longitude": longitude2,
          "Email": email2,
  
        }
        await SaveOrUpdateCampusInfo(finalArr)
        setShow3(false)
       }
       else{
        console.log("Not enterd edit validation")
       }


    }
    const handleClose3=()=>{
      setShow3(false)
    }
    
    useEffect(()=>{
      const fetchCampusListFunc = async () => {
        try {
          const data = await fetchCampusList();
          setcampusListResponse(data);
          console.log(data)
        } catch (error) {
          // Handle error if needed
        }
      };
  
      fetchCampusListFunc();
      


    },[])

    

    

    // start
  return (
    <div className="d-flex flexvaluecomp">

       <SidebarOfAdash/>
       <div className="contentpartwidthwrapper">
          <HeaderofAdash head="Campus"/>
          <div className="contentofadmindash contentflexvalue">
            <Row>
                <Col lg={8} className="m-auto">
                <Row>
                    <Col lg={4}>
                        <div className="basicinput">
                            <p></p>
                            <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus />New Campus</button>
                        </div>
                    </Col>
                    
                    <Col lg={4}>
                    <div className="basicinput">
                    <p>Active from</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activefrom}
                          onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                    <Col lg={4}>
                    <div className="basicinput">
                    <p>Active To</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                          
                          value={activeto}
                          onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                          renderInput={(params) => <TextField {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active To"
                            }} error={false} />}
                      />
                    </LocalizationProvider>
                  </div>
                    </Col>
                   
                </Row>
                
                </Col>
            </Row>
              <Row style={{marginTop:"20px"}}>
                <Col className="m-auto" lg={4}>
                  <Row>
                    <Col lg={3}>
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                      </div>
                    </Col>
                    <Col lg={9}>
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col lg={12} className="m-auto">
                  <div className="flexvaluetable bigtable3000">
                    <table>
                      <thead>
                        <tr>
                            {
                              campustableApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.campusId}</td>
                                  <td>{item.campusName}</td>
                                  <td>{item.campusTitle}</td>
                                  <td>{item.holdingNumber}</td>
                                  <td>{item.street}</td>
                                  <td>{item.area}</td>
                                  <td>{item.city}</td>
                                  <td>{item.state}</td>
                                  <td>{item.district}</td>
                                  <td>{item.phoneNumber}</td>
                                  <td>{item.mapUrl}</td>
                                  <td>{item.email}</td>
                                  <td>{item.longitude}</td>
                                  <td>{item.latitude}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={()=> handleShow3(item)} src="./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png" alt="" />  
                                      <img style={{width:"22px",marginLeft:"10px"}} onClick={()=>handleDelete(item)} src="./assets/images/dashboards/adminDashboard/icon/deleteIcon.png" alt="" />
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {campustableApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>

               {/* modal1ori */}

              <Modal dialogClassName="mymodalclsSubjectAdmin" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Campus</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                        
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Campus Name</p>
                                <div className="inputgap h35">
                                    <input style={bordercampusname1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={campusname1} onChange={(e) => setcampusname1(e.target.value)} />
                                    <label>{labelcampusname1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Campus Title</p>
                                <div className="inputgap h35">
                                    <input style={bordercampustitle1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={campustitle1} onChange={(e) => setcampustitle1(e.target.value)} />
                                    <label>{labelcampustitle1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Holdin No.</p>
                                <div className="inputgap h35">
                                    <input style={borderholdingno1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={holdingno1} onChange={(e) => setholdingno1(e.target.value)} />
                                    <label>{labelholdingno1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Street</p>
                                <div className="inputgap h35">
                                    <input style={borderstreet1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={street1} onChange={(e) => setstreet1(e.target.value)} />
                                    <label>{labelstreet1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={12} >
                            <div className="basicinput ">

                                <p>Area</p>
                                <div className="inputgap h35">
                                    <input style={borderarea1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={area1} onChange={(e) => setarea1(e.target.value)} />
                                    <label>{labelarea1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>City</p>
                                <div className="inputgap h35">
                                    <input style={bordercity1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={city1} onChange={(e) => setcity1(e.target.value)} />
                                    <label>{labelcity1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>State</p>
                                <div className="inputgap h35">
                                    <input style={borderstate1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={state1} onChange={(e) => setstate1(e.target.value)} />
                                    <label>{labelstate1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>District</p>
                                <div className="inputgap h35">
                                    <input style={borderdistrict1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={district1} onChange={(e) => setdistrict1(e.target.value)} />
                                    <label>{labeldistrict1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Map URL</p>
                                <div className="inputgap h35">
                                    <input style={bordermapurl1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={mapurl1} onChange={(e) => setmapurl1(e.target.value)} />
                                    <label>{labelmapurl1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Phone No.</p>
                                <div className="inputgap h35">
                                    <input style={borderphoneno1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={phoneno1} onChange={(e) => setphoneno1(e.target.value)} />
                                    <label>{labelphoneno1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Email</p>
                                <div className="inputgap h35">
                                    <input style={borderemail1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={email1} onChange={(e) => setemail1(e.target.value)} />
                                    <label>{labelemail1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Longitude</p>
                                <div className="inputgap h35">
                                    <input style={borderlongitude1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={longitude1} onChange={(e) => setlongitude1(e.target.value)} />
                                    <label>{labellongitude1}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Latitude</p>
                                <div className="inputgap h35">
                                    <input style={borderlatitude1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={latitude1} onChange={(e) => setlatitude1(e.target.value)} />
                                    <label>{labellatitude1}</label>
                                </div>
                            </div>
                        </Col>
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>

                {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Campus</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={20} className="m-auto">
                      <Row>
                        
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Campus Name</p>
                                <div className="inputgap h35">
                                    <input style={bordercampusname2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={campusname2} onChange={(e) => setcampusname2(e.target.value)} />
                                    <label>{labelcampusname2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Campus Title</p>
                                <div className="inputgap h35">
                                    <input style={bordercampustitle2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={campustitle2} onChange={(e) => setcampustitle2(e.target.value)} />
                                    <label>{labelcampustitle2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Holding No.</p>
                                <div className="inputgap h35">
                                    <input style={borderholdingno2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={holdingno2} onChange={(e) => setholdingno2(e.target.value)} />
                                    <label>{labelholdingno2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Street</p>
                                <div className="inputgap h35">
                                    <input style={borderstreet2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={street2} onChange={(e) => setstreet2(e.target.value)} />
                                    <label>{labelstreet2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={22} >
                            <div className="basicinput ">

                                <p>Area</p>
                                <div className="inputgap h35">
                                    <input style={borderarea2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={area2} onChange={(e) => setarea2(e.target.value)} />
                                    <label>{labelarea2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>City</p>
                                <div className="inputgap h35">
                                    <input style={bordercity2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={city2} onChange={(e) => setcity2(e.target.value)} />
                                    <label>{labelcity2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>State</p>
                                <div className="inputgap h35">
                                    <input style={borderstate2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={state2} onChange={(e) => setstate2(e.target.value)} />
                                    <label>{labelstate2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>District</p>
                                <div className="inputgap h35">
                                    <input style={borderdistrict2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={district2} onChange={(e) => setdistrict2(e.target.value)} />
                                    <label>{labeldistrict2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Map URL</p>
                                <div className="inputgap h35">
                                    <input style={bordermapurl2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={mapurl2} onChange={(e) => setmapurl2(e.target.value)} />
                                    <label>{labelmapurl2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Phone No.</p>
                                <div className="inputgap h35">
                                    <input style={borderphoneno2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={phoneno2} onChange={(e) => setphoneno2(e.target.value)} />
                                    <label>{labelphoneno2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Email</p>
                                <div className="inputgap h35">
                                    <input style={borderemail2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={email2} onChange={(e) => setemail2(e.target.value)} />
                                    <label>{labelemail2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pr7">
                            <div className="basicinput ">

                                <p>Longitude</p>
                                <div className="inputgap h35">
                                    <input style={borderlongitude2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={longitude2} onChange={(e) => setlongitude2(e.target.value)} />
                                    <label>{labellongitude2}</label>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="pl7">
                            <div className="basicinput ">

                                <p>Latitude</p>
                                <div className="inputgap h35">
                                    <input style={borderlatitude2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "#ebebeb" }} type="text" value={latitude2} onChange={(e) => setlatitude2(e.target.value)} />
                                    <label>{labellatitude2}</label>
                                </div>
                            </div>
                        </Col>
                        
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose3}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>
              </Modal>
              </div>
              </div>
              </div>
  )
}

export default CampusComp